export default __webpack_public_path__ + "images/next_477a7b.svg";